import React, { useEffect, useState } from 'react'
import moment from 'moment-timezone'
import { useSelector } from 'react-redux'
import CheckboxTile from '~/Common-Objects/UI/Forms/CheckboxTile'
import Icons from '~/Common-Objects/UI/Icons/index'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'

const hours = Array.from({ length: 24 }, (_, i) => ({ label: i < 10 ? '0' + i : i, value: i }))
const minutes = Array.from({ length: 60 }, (_, i) => ({ label: i < 10 ? '0' + i : i, value: i }))

export default function StartDate({ startDate, setStartDate, options }) {
    const user = useSelector((state) => state.user)
    const hasValidStartDate = startDate && moment(startDate).isValid()
    const tzStartDate = hasValidStartDate ? moment.utc(startDate).tz(user.userData.timeZone) : null
    const tzNow = moment.tz(user.userData.timeZone)

    const [sendNow, setSendNow] = useState(hasValidStartDate ? tzStartDate.isSameOrBefore(tzNow) : false)

    const changeDate = (_, v) => {
        if (!v || !tzStartDate) return

        // Parse the selected date and combine with existing time
        const selectedDate = moment(v) // This will be in local date format
        const newDate = tzStartDate
            .clone()
            .year(selectedDate.year())
            .month(selectedDate.month())
            .date(selectedDate.date())

        setStartDate(newDate.utc().toDate())
    }

    const changeHour = (e) => {
        const hour = parseInt(e.target.value, 10)
        if (tzStartDate && !isNaN(hour)) {
            const newDate = tzStartDate.clone().hour(hour)
            setStartDate(newDate.utc().toDate())
        }
    }

    const changeMinute = (e) => {
        const minute = parseInt(e.target.value, 10)
        if (tzStartDate && !isNaN(minute)) {
            const newDate = tzStartDate.clone().minute(minute)
            setStartDate(newDate.utc().toDate())
        }
    }

    useEffect(() => {
        if (options?.timeBasedSending) {
            changeMinute({ target: { value: 0 } })
        }
    }, [options?.timeBasedSending])

    return (
        <>
            <div className='row'>
                <div className='col-xs'>
                    <CheckboxTile
                        name='startDate'
                        value='now'
                        checked={sendNow}
                        onChange={() => {
                            setStartDate(tzNow.clone().minute(0).utc().toDate())
                            setSendNow(true)
                        }}
                    >
                        <div className='quickFlex' style={{ gap: 16 }}>
                            <Icons icon='paperPlane' style={{ width: 20, height: 20 }} color='var(--neutral-800)' />
                            <div>
                                <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--neutral-950)' }}>Send Now</div>
                                <div style={{ fontSize: 12, fontWeight: 400, color: 'var(--neutral-800)' }}>
                                    Send your campaign immediately.
                                </div>
                            </div>
                        </div>
                    </CheckboxTile>
                </div>
                <div className='col-xs'>
                    <CheckboxTile
                        name='startDate'
                        value='later'
                        checked={!sendNow}
                        onChange={() => {
                            setStartDate(tzNow.clone().add(1, 'hour').minute(0).utc().toDate())
                            setSendNow(false)
                        }}
                    >
                        <div className='quickFlex' style={{ gap: 16 }}>
                            <Icons icon='clock' color='var(--neutral-800)' />
                            <div>
                                <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--neutral-950)' }}>
                                    Send Later
                                </div>
                                <div style={{ fontSize: 12, fontWeight: 400, color: 'var(--neutral-800)' }}>
                                    Schedule for a specific day and time.
                                </div>
                            </div>
                        </div>
                    </CheckboxTile>
                </div>
            </div>
            {!sendNow && tzStartDate?.isValid() && (
                <div className='row' style={{ marginTop: 16 }}>
                    <div className='col-xs-12 col-sm-12 col-md-8 col-lg-6 quickFlex' style={{ gap: 16 }}>
                        <TextInput type='date' value={tzStartDate.format('YYYY-MM-DD')} onChange={changeDate} />
                        <div className='quickFlex' style={{ gap: 8 }}>
                            <Select data={hours} value={tzStartDate.hour()} onChange={changeHour} />
                            <div>:</div>
                            <Select
                                data={minutes}
                                disabled={options?.timeBasedSending}
                                value={tzStartDate.minute()}
                                onChange={changeMinute}
                            />
                        </div>
                    </div>
                </div>
            )}
            <div style={{ color: 'var(--neutral-800)', fontSize: 12, fontWeight: 400, marginTop: 16 }}>
                Timezone: {user.userData.timeZone} ({moment.tz(user.userData.timeZone).format('Z')})
            </div>
        </>
    )
}
